import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { accessToken } = useContext(AuthContext); // or { accessToken }

  console.log("ProtectedRoute: accessToken: ", accessToken);
  // If user is non-null, they're considered logged in
  if (accessToken) {
    return children;
  }
  else {
    <Navigate to="/" />;
  }
};

export default ProtectedRoute;
